import React, { useState, useEffect, useRef } from "react";
import { SocialShare } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";
import { object, string, bool } from "prop-types";

import SocialShareTemplate from "../SocialShareTemplate";
import { FontIncrease, FontDecrease, Share, Print } from "../../atoms/icons/StoryPageIcons";
import ShareAllTemplate from "../ShareAllTemplate";
import BookmarkViewIcon from "../../atoms/BookmarkViewIcon";
import { fontVariation, googleTagEvents } from "../../utils/utils";

import "./storyPageMetaDataIcons.m.css";

const StoryPageMetaDataIcons = ({
  storyData,
  color1 = "#eee",
  color2 = "#222",
  isVideoStory,
  publisherAttributes,
  clickFrom,
}) => {
  const [elements, setElements] = useState(null);
  const [customGalleryElements, setCustomGalleryElements] = useState(null);
  const [isSocialShare, setSocialShare] = useState(false);
  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setSocialShare(false);
    }
  };

  const toggleShare2 = () => {
    setSocialShare(!isSocialShare);
  };

  const printStory = (storyUrl) => {
    googleTagEvents("social-share", `Print ${clickFrom}`, "");
    window.onafterprint = function (event) {
      window.location.href = storyUrl;
    };
    window.print();
  };

  useEffect(() => {
    if (global.deviceWidth > 876) {
      document.addEventListener("click", handleClickOutside, true);
      return () => {
        document.removeEventListener("click", handleClickOutside, true);
      };
    }
  });

  useEffect(() => {
    const storyPage = document.getElementsByClassName("storyCard");

    const htmlElements = Array.from(storyPage)
      .map((element) => {
        const paraElements = element.getElementsByTagName("P");
        const anchorElements = element.getElementsByTagName("A");
        const h1Elements = element.getElementsByTagName("H1");
        const h2Elements = element.getElementsByTagName("H2");
        const spanElements = element.getElementsByTagName("SPAN");
        const figCaptionElements = element.getElementsByTagName("FIGCAPTION");
        const blockQuoteElements = element.getElementsByTagName("BLOCKQUOTE");
        const recentElements = Array.from(paraElements).concat(
          Array.from(anchorElements),
          Array.from(h1Elements),
          Array.from(h2Elements),
          Array.from(spanElements),
          Array.from(figCaptionElements),
          Array.from(blockQuoteElements)
        );
        return recentElements;
      })
      .reduce((prev, next) => {
        return prev.concat(next);
      });

    setElements(htmlElements);
  }, [storyData]);

  useEffect(() => {
    setCustomGalleryElements(document.getElementsByClassName("custom-galley-image"));
  }, []);

  return (
    <div styleName="icons" className="meta-data-icons">
      <SocialShare
        template={SocialShareTemplate}
        title={storyData.headline}
        fullUrl={encodeURI(storyData.url)}
        color1={color1}
        color2={color2}
        clickFrom={clickFrom || ""}
      />
      <span styleName="share-button" ref={ref}>
        <span onClick={toggleShare2}>
          <Share color1={color1} color2={color2} />
        </span>
        {isSocialShare && (
          <SocialShare
            template={ShareAllTemplate}
            title={storyData.headline}
            fullUrl={encodeURI(storyData.url)}
            toggleShare2={toggleShare2}
            onScroll={true}
            clickFrom={clickFrom || ""}
          />
        )}
      </span>
      {!isVideoStory && (
        <span
          onClick={(e) => {
            fontVariation("add", elements, customGalleryElements, publisherAttributes.lang);
            googleTagEvents("social-share", `Font Increase ${clickFrom || ""}`, "");
          }}
          className="font-increase"
        >
          <FontIncrease className="font-increase" lang={publisherAttributes.lang} />
        </span>
      )}
      {!isVideoStory && (
        <span
          onClick={(e) => {
            fontVariation("minus", elements, customGalleryElements, publisherAttributes.lang);
            googleTagEvents("social-share", `Font Decrease ${clickFrom || ""}`, "");
          }}
          className="font-decrease"
        >
          <FontDecrease className="font-decrease" lang={publisherAttributes.lang} />
        </span>
      )}
      {publisherAttributes.showBookmark && (
        <span className="bookmark">
          <BookmarkViewIcon story={storyData.story} color1={color1} color2={color2} clickFrom={clickFrom || ""} />
        </span>
      )}
      <span onClick={() => printStory(encodeURI(storyData.url))} styleName="print-link">
        <Print bgcolor="#eee" color="#222" />
      </span>
    </div>
  );
};

const mapStateToProps = (state) => ({
  storyData: get(state, ["headerReducer", "showStoryHeader"], {}),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, "")(StoryPageMetaDataIcons);

StoryPageMetaDataIcons.propTypes = {
  storyData: object,
  color1: string,
  color2: string,
  isVideoStory: bool,
  publisherAttributes: object,
  clickFrom: string,
};
